import { render } from "./sidebar.vue?vue&type=template&id=2495e7ee&scoped=true&ts=true"
import script from "./sidebar.vue?vue&type=script&lang=ts"
export * from "./sidebar.vue?vue&type=script&lang=ts"

import "./sidebar.vue?vue&type=style&index=0&id=2495e7ee&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2495e7ee"]])

export default __exports__